<kion-not-found
  [headline]="'error.notFound.headline' | translate"
  [text]="'error.notFound.description' | translate"
  [backToHomeText]="'error.notFound.button.description' | translate"
  [withSlope]="isLR"
  link=""
></kion-not-found>
